import React, { useState } from 'react';
import TablePagination from '@mui/material/TablePagination';
import {
  Button,
  Card,
  FormControlLabel,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography
} from '@mui/material';
import { GreenSwitch } from '../Common/GreenSwitch';

import PropTypes from 'prop-types';

const PaginationTableWithFuncBtn = ({
  rowData,
  colName,
  dataFrame,
  col_size,
  sortBy = null,
  delFunc = null,
  editModalOpen = null,
  switchOnChange = null,
  extraFunc = null,
  extraBtnLabel = '',
  isExtraBtnVisible = null,
  selectedMemberNos,
  setSelectedMemberNos,
  tableType,
  ...props
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [orderBy, setOrderBy] = useState('');
  const [order, setOrder] = useState('');

  const handleSortRequest = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };

  // Comparator function generator based on the order and orderBy properties
  const getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };

  // Function to stabilize and sort the rows based on the specified comparator
  const sortedRowInformation = (rowArray, comparator) => {
    // Sort the row array using the provided comparator
    const sortedRows = [...rowArray].sort(comparator);
    return sortedRows;
  };
  const handleButtonClick = (index, direction) => {
    handleSortRequest(sortBy[index]);
    const buttons = document.querySelectorAll('.arrow-button');
    buttons.forEach((button, i) => {
      button.style.color = '#E2E2E2'; // Set color to default
    });
    document.getElementById(`arrow-button-${index}-${direction}`).style.color = 'black';
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getValueFromNestedObject = (obj, keyPath) => {
    return keyPath.split('.').reduce((acc, key) => acc && acc[key], obj);
  };

  return (
    <React.Fragment>
      <TableContainer sx={{ border: 1, borderColor: '#F2F2F2', padding: '0px' }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead
            sx={{
              '& .MuiTableCell-head': {
                backgroundColor: '#F2F2F2',
                padding: '10px 16px',
              },
            }}
          >
            <TableRow>
              {sortBy !== null
                ? colName.map((val, index) => (
                    <TableCell key={index} sx={{ fontWeight: 'bold' }}>
                      <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '8px' }}>{val}</span>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <button
                            onClick={() => handleButtonClick(index, 'up')}
                            id={`arrow-button-${index}-up`}
                            className="arrow-button"
                            style={{
                              color: '#E2E2E2',
                              border: 'none',
                              background: 'none',
                              cursor: 'pointer',
                              fontSize: '8px',
                              lineHeight: '8px',
                            }}
                          >
                            ▲
                          </button>
                          <button
                            onClick={() => handleButtonClick(index, 'down')}
                            id={`arrow-button-${index}-down`}
                            className="arrow-button"
                            style={{
                              color: '#E2E2E2',
                              border: 'none',
                              background: 'none',
                              cursor: 'pointer',
                              fontSize: '8px',
                              lineHeight: '8px',
                            }}
                          >
                            ▼
                          </button>
                        </div>
                      </div>
                    </TableCell>
                  ))
                : colName.map((val, index) => (
                    <TableCell key={index} sx={{ fontWeight: 'bold' }}>
                      {val}
                    </TableCell>
                  ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowData.length > 0 ? (
              (sortBy !== null ? sortedRowInformation(rowData, getComparator(order, orderBy)) : rowData)
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((val, index) => (
                  <TableRow key={index} hover>
                    {dataFrame.map((frameVal, frameIndex) =>
                      frameVal.hasOwnProperty('isClick') ? (
                        <TableCell
                          key={frameIndex}
                          style={{
                            width: col_size[frameIndex],
                            padding: '10px 15px',
                            textAlign:
                              frameVal.hasOwnProperty('editBtn') && frameVal.hasOwnProperty('delBtn')
                                ? 'left'
                                : frameVal.hasOwnProperty('editBtn')
                                ? 'left'
                                : 'right',
                          }}
                        >
                          <>
                            {frameVal.hasOwnProperty('editBtn') && (
                              <Button
                                style={{
                                  color: '#323232',
                                  fontSize: '13px',
                                  fontWeight: 'bold',
                                  padding: '0px',
                                }}
                                variant="text"
                                onClick={() => {
                                  editModalOpen(val.uuid || val.id);
                                }}
                              >
                                編輯
                              </Button>
                            )}
                            {frameVal.hasOwnProperty('delBtn') && (
                              <Button
                                style={{
                                  color: '#323232',
                                  fontSize: '13px',
                                  fontWeight: 'bold',
                                  padding: '0px',
                                }}
                                variant="text"
                                onClick={() => {
                                  delFunc(val.uuid || val.id);
                                }}
                              >
                                刪除
                              </Button>
                            )}
                            {frameVal.hasOwnProperty('extraBtn') &&
                              extraFunc &&
                              (isExtraBtnVisible === null || isExtraBtnVisible(val)) && (
                                <Button
                                  style={{
                                    color: '#323232',
                                    fontSize: '13px',
                                    fontWeight: 'bold',
                                    padding: '0px',
                                  }}
                                  variant="text"
                                  onClick={() => {
                                    extraFunc(val.uuid || val.id);
                                  }}
                                >
                                  {extraBtnLabel}
                                </Button>
                              )}
                          </>
                        </TableCell>
                      ) : frameVal.hasOwnProperty('isSlide') ? (
                        <TableCell
                          key={frameIndex}
                          style={{ width: col_size[frameIndex], padding: '10px 15px', textAlign: 'left' }}
                        >
                          <>
                            <FormControlLabel
                              checked={!val.is_cancel}
                              onChange={() => switchOnChange(val.uuid || val.id)}
                              control={<GreenSwitch />}
                              label={
                                <Typography sx={{ fontSize: '14px' }}>
                                  {val.is_cancel ? '停用' : '啟用'}
                                </Typography>
                              }
                              labelPlacement="start"
                            />
                          </>
                        </TableCell>
                      ) : (
                        // <TableCell key={frameIndex} style={{ width: col_size[frameIndex], padding: '10px 15px' }}>
                        <TableCell
                          key={frameIndex}
                          style={{
                            width: col_size[frameIndex],
                            padding: '10px 15px',
                            maxWidth: '300px',
                            overflowX: 'auto',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {getValueFromNestedObject(val, frameVal.keyName)}
                        </TableCell>
                      )
                    )}
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell>查無資料</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        className="mt-3"
        component="div"
        rowsPerPageOptions={[5, 10, 20, { label: 'All', value: rowData.length }]}
        count={rowData.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        labelRowsPerPage="每頁顯示 :"
        onRowsPerPageChange={handleChangeRowsPerPage}
        SelectProps={{ renderValue: (value) => (value === rowData.length ? 'All' : value) }}
        sx={{
          '.MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel': {
            marginTop: '1em',
            marginBottom: '1em',
          },
        }}
      />
    </React.Fragment>
  );
};
export default PaginationTableWithFuncBtn;

PaginationTableWithFuncBtn.propTypes = {
  // table的資料
  rowData: PropTypes.array.isRequired,
  // table欄位顯示名稱
  colName: PropTypes.array.isRequired,
  // 如何取得table的資料
   dataFrame: PropTypes.arrayOf(
      PropTypes.shape({
        keyName: PropTypes.string.isRequired,
      })
    ).isRequired,
  };

PaginationTableWithFuncBtn.defaultProps = {};
